export default class ChatBotTipoNoApiAutorizacaoTiposEnum {
    static BearerToken = 1
    static BasicAuth = 2
}
